import * as styles from "./HeroHome.module.css";
import openingImage from "../../assets/webp/opening-home.webp";
import unlockImage from "../../assets/images/unlock.png";
import { useEffect, useState } from "react";
import HighlightsSlider from "../HighlightsSlider/HighlightsSlider";
import { CTA } from "../CTA/CTA";
import QRCode from "../QRCode/QRCode";

const HeroHome = () => {
  const [ctaStatus, setCtaStatus] = useState<"idle" | "success" | "error">(
    "idle"
  );
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className={styles.heroHomeContainer}>
        <div
          className={`${styles.openingContainer} ${
            ctaStatus === "success" ? styles.hiddenOpeningContainer : ""
          }`}
        >
          <div className={styles.openingParent}>
            <div className={styles.openingTextParent}>
              <img
                src={openingImage}
                alt="Returns"
                className={styles.openingImage}
              />
              <h1 className={styles.openingText}>
                <span className="span-block">
                  Your <span className={styles.openingTextGold}>wealth</span>
                </span>
                <span className="span-block">building team</span>
              </h1>
            </div>
            <p className={styles.openingDescription}>
              You relax! We analyze & fine-tune opportunities for wealth
              creation
            </p>
          </div>
        </div>

        {ctaStatus === "success" && (
          <div className={styles.unlockContainer}>
            <div className={styles.openingParent}>
              <div className={styles.openingTextParent}>
                <img
                  src={unlockImage}
                  alt="Unlock 3 stocks"
                  className={styles.unlockImage}
                />
                <h1 className={styles.openingText}>
                  <span className="span-block">You’ve unlocked</span>
                  <span className={styles.openingTextGold}>3 free</span>

                  <span> stocks ~₹300</span>
                </h1>
              </div>
              <p className={styles.openingDescription}>
                Signup on Returns App to claim them!
              </p>
            </div>
          </div>
        )}

        {ctaStatus === "success" ? (
          isMobile ? (
            <CTA variant="large" status={ctaStatus} setStatus={setCtaStatus} />
          ) : (
            <div>
              <QRCode />
            </div>
          )
        ) : (
          <CTA variant="large" status={ctaStatus} setStatus={setCtaStatus} />
        )}

        <div className="highlightsSliderParent">
          <HighlightsSlider />
        </div>
      </div>
    </>
  );
};

export default HeroHome;
